import { render, staticRenderFns } from "./courseStudentCount.vue?vue&type=template&id=532c63e0&"
import script from "./courseStudentCount.vue?vue&type=script&lang=js&"
export * from "./courseStudentCount.vue?vue&type=script&lang=js&"
import style0 from "./courseStudentCount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports